import _functionUncurryThis from "../internals/function-uncurry-this";
var exports = {};
var uncurryThis = _functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
exports = uncurryThis(1 .valueOf);
export default exports;